import AccountScreen from "./AccountScreen";
import SettingsScreen, { navigationTitle as settingsNavigationTitle } from "./SettingsScreen";
import EditScreen, { navigationTitle as editNavigationTitle } from "./EditScreen";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { AccountStackParamList } from "./types";
import { headerScreenOptions } from "../../components/HeaderBackButton";
import InvoiceListScreen from "./InvoiceListScreen";
import { useFeatureFlags } from "../../hooks/useFlagr";

export const Stack = createNativeStackNavigator<AccountStackParamList>();

export default function () {
  const flags = useFeatureFlags();
  return (
    <Stack.Navigator id="account" screenOptions={headerScreenOptions}>
      <Stack.Screen name="AccountShow" component={AccountScreen} options={{ headerShown: false, title: "My Account" }} />
      <Stack.Screen name="AccountSettings" component={SettingsScreen} options={{ title: settingsNavigationTitle }} />
      <Stack.Screen name="AccountEdit" component={EditScreen} options={{ title: editNavigationTitle }} />
      {flags["membership-unified-invoices"] && (
        <Stack.Screen name="InvoiceList" component={InvoiceListScreen} options={{ title: "Billing & Payments" }} />
      )}
    </Stack.Navigator>
  );
}
